// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"d338ce67","732":"aa80803e","977":"5348fd51"}[chunkId] + ".chunk.js";
};